import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import { ProtocolStudentResponse } from "../../models/dtos";
import { Button } from "primereact/button";
import CustomInputText from "../../components/forms/CustomInputText";
import { useState } from "react";
import { protocolsApi } from "../../services/protocols/protocolsApi";
import { Tag } from "primereact/tag";

interface ProtocolStudentsListProps {
  protocolId: number;
  protocolStudents: ProtocolStudentResponse[];
  selectedStudents: ProtocolStudentResponse[];
  onSelectionChange: (students: ProtocolStudentResponse[]) => void;
}

const ProtocolStudentsList = ({
  protocolId,
  protocolStudents,
  selectedStudents,
  onSelectionChange,
}: ProtocolStudentsListProps) => {
  const [facultyNumber, setFacultyNumber] = useState("");
  const [addProtocolStudentByFn] = protocolsApi.useAddProtocolStudentByFnMutation();

  const handleAddStudentByFn = () => {
    addProtocolStudentByFn({ protocolId: protocolId, fn: facultyNumber });
  };

  return (
    <Card title="Списък с потенциални студенти" className="mt-4 shadow-4">
      <DataTable
        value={protocolStudents}
        stripedRows
        selectionMode="multiple"
        selection={selectedStudents}
        onSelectionChange={(e) => onSelectionChange(e.value)}
        dragSelection
      >
        <Column selectionMode="multiple" headerStyle={{ width: "3rem" }} />
        <Column
          header="ФН"
          style={{ width: "140px" }}
          sortField="facultyNumber"
          sortable
          body={(rowData) => (
            <div className="flex align-items-center">
              <span>{rowData.facultyNumber}</span>
              <a href={`/students/${rowData.studentId}`} target="_blank" rel="noopener noreferrer" className="ml-2">
                <Button label="" icon="pi pi-external-link" size="small" severity="secondary" />
              </a>
            </div>
          )}
        />
        <Column field="studentName" header="Име на студент" sortable />
        <Column field="groupName" header="Група" sortable />
        <Column field="specialityName" header="Специалност" sortable />
        <Column field="specialityModeName" header="Форма на обучение" sortable />
        <Column field="specialityTypeName" header="Вид обучение" sortable />
        <Column field="degreeName" header="ОКС" sortable />
        <Column field="semester" header="Семестър" sortable />
        <Column
          field="status"
          header="Статус"
          sortable
          body={(rowData) => (
            <Tag
              value={rowData.status}
              severity={rowData.status === "приключил" ? "danger" : rowData.status === "прекъснал" ? "warning" : "info"}
            />
          )}
        />
      </DataTable>

      <div className="mt-4 flex flex-row align-items-center">
        <CustomInputText
          id="facultyNumber"
          label="Добави студент по ФН"
          value={facultyNumber}
          onChange={(e: any) => setFacultyNumber(e.target.value)}
        />
        <Button label="" icon="pi pi-plus" onClick={handleAddStudentByFn} className="mt-2" />
      </div>
    </Card>
  );
};

export default ProtocolStudentsList;